/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2, breakpoints } from '@coursera/cds-core';

import LazyImgix from 'bundles/page/components/shared/LazyImgix';
import type { Instructor } from 'bundles/video-logged-out-page/types/vlpSharedTypes';

import _t from 'i18n!nls/video-logged-out-page';

type Props = {
  instructors: Instructor[];
};

const IMGIX_PARAMS = {
  fit: 'crop',
};

const IMG_HEIGHT = 80;
const IMG_WIDTH = 80;

const styles = {
  instructorPhoto: css`
    .perfect-circle {
      border-radius: 50%;
    }
  `,
  instructorsInfoList: css`
    list-style-type: none;
    padding: 0;
  `,
  courseInstructor: css`
    display: flex;
    margin-top: var(--cds-spacing-300);
    ${breakpoints.down('sm')} {
      flex-direction: column;
      align-items: center;
      text-align: center;
    }
  `,
  instructorInfo: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: var(--cds-spacing-300);
    ${breakpoints.down('sm')} {
      margin-left: 0;
      margin-top: var(--cds-spacing-100);
    }
  `,
};

const CourseInstructors: React.FC<Props> = ({ instructors }) => {
  if (!instructors || !instructors.length) {
    return null;
  }

  return (
    <div className="rc-CourseInstructorsCds vlp-container-section">
      <Typography2 component="h3" variant="subtitleMedium" className="taught-by">
        {_t('Taught By')}
      </Typography2>
      <ul className="instructors-info-list" css={styles.instructorsInfoList}>
        {instructors.map((instructor) => {
          const { fullName, photo, title } = instructor;
          if (!fullName || !photo) {
            return null;
          }

          return (
            <li className="course-instructor" key={`instructor-${fullName}`} css={styles.courseInstructor}>
              <div className="instructor-photo" css={styles.instructorPhoto}>
                <LazyImgix
                  alt={fullName}
                  src={photo}
                  maxHeight={IMG_HEIGHT}
                  maxWidth={IMG_WIDTH}
                  height={IMG_HEIGHT}
                  width={IMG_WIDTH}
                  imgParams={IMGIX_PARAMS}
                  className="perfect-circle"
                />
              </div>
              <div className="instructor-info-cds" css={styles.instructorInfo}>
                <Typography2 className="instructor-name" variant="bodyPrimary" component="h4">
                  {fullName}
                </Typography2>
                <Typography2 component="p" variant="bodyPrimary">
                  {title}
                </Typography2>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default CourseInstructors;
